import React, { useState } from "react";
import FormMember from "./FormMember";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";
import ModalBox from "../../ui/ModalBox";

const AddMember = () => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };

  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add New Member
      </Typography>
      <FormMember handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new Member"
        name="Member"
      />
    </>
  );
};

export default AddMember;
